export const SPENT_ON_APPLIANCE_ACTIONS = {
  CHART_LOADED: "SPENT_ON_APPLIANCE_CHART_LOADED",
  IMAGE_LOADED: "SPENT_ON_APPLIANCE_IMAGE_LOADED",
  IMAGES_TO_BE_LOADED: "SPENT_ON_APPLIANCE_IMAGE_TO_BE_LOADED",
  FETCH_DATA: "FETCH_SPENT_ON_APPLIANCE_DATA",
  UPDATE_CHARTS_TO_BE_LOADED: "UPDATE_CHARTS_TO_BE_LOADED"
};

export const onChartLoad = () => ({
  type: SPENT_ON_APPLIANCE_ACTIONS.CHART_LOADED
});

export const updateChartsToBeLoaded = () => ({
  type: SPENT_ON_APPLIANCE_ACTIONS.UPDATE_CHARTS_TO_BE_LOADED
});

export const onImageLoad = () => ({
  type: SPENT_ON_APPLIANCE_ACTIONS.IMAGE_LOADED
});

export const updateImagesToBeLoaded = (payload) => ({
  type: SPENT_ON_APPLIANCE_ACTIONS.IMAGES_TO_BE_LOADED,
  payload
});